import React, { useEffect, useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentInner } from '../../layout/Content'
import { customersAccountsListControllerContext } from './CustomersAccountsListController'
import CustomersAccountsListInnerStyle from './css/CustomersAccountsListInnerStyle'
import CustomerAccountItemController from '../customer_account_item/CustomerAccountItemController'
import { appContext } from '../../../App'
import { formatNumber } from '../../utilities/utilities'

function CustomersAccountsListInner() {
  const app = useContext(appContext)
  const customersAccountsListController = useContext(customersAccountsListControllerContext)
  const {
    showRegisterCustomerAccountForm, addSelectedCustomerAccount, removeSelectedCustomerAccount,
    setAllCheck, sortCustomersAccounts, customersAccounts, customersAccountsSorted, foundEmptyCreditAccounts
  } = customersAccountsListController

  const [selectAll, setSelectAll] = customersAccountsListController.selectAll
  const [customerSaved, setCustomerSaved] = customersAccountsListController.customerSaved
  const startSlice = customersAccountsListController.startSlice[0]
  const endSlice = customersAccountsListController.endSlice[0]
  const setContent = app.content[1]
  const [sortBy, setSortBy] = customersAccountsListController.sortBy

  const onClickListItem = async (e) =>  {
    if (app.client.signed_in !== 'admin')
      if (!app.client.signed_in.user_access.customers_accounts_fc) return

    if ((e.target.className === 'customer-checkbox') || (e.target.className === 'edit-customer-account-details-btn')) return

    const customer_account_id = e.target.parentNode.id
    const customerAccountItemControllerProps = { id: customer_account_id }
    setContent(<CustomerAccountItemController { ...customerAccountItemControllerProps } />)
  }

  const onClickEditCustomerAccountDetails = (e) => {
    const customerAccount = e.target.parentNode.parentNode
    showRegisterCustomerAccountForm(app, customerAccount.id)
  }

  const onCheckCustomerAccount = (e) => {
    const customerCheckBox = e.target
    const customerAccount = e.target.parentNode.parentNode
    customerCheckBox.checked ? addSelectedCustomerAccount(customerAccount.id) : removeSelectedCustomerAccount(customerAccount.id)
    setSelectAll(false)
  }

  const onClickSelectAll = () => {
    setAllCheck(!selectAll)
    setSelectAll(!selectAll)
  }

  const onClickSort = (e) => {
    const header = e.target.closest('.title-header')
    sortCustomersAccounts(header.id)
    setSortBy(header.id)
  }

  useEffect(() => {
    if (customerSaved) setCustomerSaved(false)
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerSaved])

  let userHaveFC = true
  if (app.client.signed_in !== 'admin') userHaveFC = app.client.signed_in.user_access.customers_accounts_fc

  return (
    <ContentInner>
      <div className='customer-accounts-list-container'>
        <table className='table striped-table'>
          <thead>
            <tr>
              <th style={{textAlign: 'left'}}>
                <div
                  id='date_time_created'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>DateTime Created</div>
                  <span>
                    {
                      (sortBy === 'date_time_created') ?
                        (!customersAccountsSorted ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>)
                      : ''
                    }
                  </span>
                </div>
              </th>
              <th style={{ display: 'none', textAlign: 'left'}}>
                <div
                  id='_id'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Account Number</div>
                  <span>
                    {
                      (sortBy === '_id') ?
                        (!customersAccountsSorted ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>)
                      : ''
                    }
                  </span>
                </div>
              </th>
              <th style={{textAlign: 'left'}}>
                <div
                  id='account_name'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Account Name</div>
                  <span>
                    {
                      (sortBy === 'account_name') ?
                        (!customersAccountsSorted ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>)
                      : ''
                    }
                  </span>
                </div>
              </th>
              <th style={{textAlign: 'center'}}>
                <div
                  id='total_credit_accounts'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Total Credit Accounts</div>
                  <span>
                    {
                      (sortBy === 'total_credit_accounts') ?
                        (!customersAccountsSorted ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>)
                      : ''
                    }
                  </span>
                </div>
              </th>
              <th style={{textAlign: 'right'}}>
                <div
                  id='credit_total_amount'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Total Credit</div>
                  <span>
                    {
                      (sortBy === 'credit_total_amount') ?
                        (!customersAccountsSorted ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>)
                      : ''
                    }
                  </span>
                </div>
              </th>
              <th style={{textAlign: 'right'}}>
                <div
                  id='credit_balance'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Credit Balance</div>
                  <span>
                    {
                      (sortBy === 'credit_balance') ?
                        (!customersAccountsSorted ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>)
                      : ''
                    }
                  </span>
                </div>
              </th>
              <th>
                <div
                  id='remarks'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Remarks</div>
                  <span>
                    {
                      (sortBy === 'remarks') ?
                        (!customersAccountsSorted ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>)
                      : ''
                    }
                  </span>
                </div>
              </th>

              {
                (userHaveFC) ? <th style={{textAlign: 'center'}} className='empty-header'>Actions</th> : null
              }

              <th className='empty-header' style={{display: (foundEmptyCreditAccounts && userHaveFC) ? 'block' : 'none'}}>
                <button
                  type="button"
                  className={(!foundEmptyCreditAccounts) ? 'pospro-action-btn disabled-button' : 'pospro-action-btn'}
                  id="select-all-btn"
                  title="Select/Unselect all selectable items on the list"
                  disabled={!foundEmptyCreditAccounts}
                  onClick={onClickSelectAll}>
                  {
                    (selectAll) ? (<span style={{fontSize: '1rem'}}><FontAwesomeIcon icon='check-square'/>&nbsp;</span>)
                    : (<span style={{fontSize: '1rem'}}><FontAwesomeIcon icon='square'/>&nbsp;</span>)
                  }
                </button>
              </th>
            </tr>
          </thead>
          {
            customersAccounts.slice(startSlice, endSlice).map((customerAccount, index) => (
              <tbody key={index} className='table-body'>
                <tr id={customerAccount._id} onClick={onClickListItem}>
                  <td>
                    <div>{new Date(customerAccount.date_time_created).toLocaleString("en-us", { timeZone: customerAccount.client_timezone })}</div>
                    <div style={{ fontSize: "0.8em" }}>{customerAccount.client_timezone}</div>
                  </td>
                  <td style={{display: 'none'}}>{customerAccount._id.toUpperCase()}</td>
                  <td>{customerAccount.customer_details.account_name}</td>
                  <td style={{textAlign: 'center'}}>{customerAccount.credit_accounts.length}</td>
                  <td style={{textAlign: 'right'}}>P{formatNumber(customerAccount.credit_total_amount)}</td>
                  <td style={{textAlign: 'right', color: 'red', fontWeight: 'bold'}}>P{formatNumber(customerAccount.credit_total_balance)}</td>
                  <td style={{textAlign: 'center'}}>{customerAccount.customer_details.remarks}</td>
                  {
                    (userHaveFC)
                    ? <td style={{textAlign: 'center'}}>
                        <button
                          onClick={onClickEditCustomerAccountDetails}
                          className='edit-customer-account-details-btn'>
                          Edit Info
                        </button>
                      </td>
                    : null
                  }
                  <td style={{display: (foundEmptyCreditAccounts && userHaveFC) ? 'block' : 'none'}}>
                  {
                    (customerAccount.credit_accounts.length === 0)
                    ? <input
                        type='checkbox'
                        onClick={onCheckCustomerAccount}
                        id={index}
                        className='customer-checkbox'
                      />
                    : null
                  }
                  </td>
                </tr>
              </tbody>
            ))
          }
        </table>
      </div>
      <CustomersAccountsListInnerStyle signed_in={app.client.signed_in} />
    </ContentInner>
  )
}

export default React.memo(CustomersAccountsListInner)
